<template>
  <div class="changePassword">
    <div class="form-wrapper">
      <div class="form-title">{{ $t('Reset Password') }}</div>
      <el-form :model="resetForm" label-position="top" status-icon :rules="rules" ref="resetForm" label-width="100px" class="my-form" v-loading="fullLoading">
        <el-form-item :label="$t('New Password')" prop="newPSW">
          <el-input show-password v-model="resetForm.newPSW" autocomplete="off" @input="inputPassword"></el-input>
        </el-form-item>
        <el-form-item :label="$t('Confirm New Password')" prop="confirmNewPSW">
          <el-input show-password v-model="resetForm.confirmNewPSW" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item class="submitWrapper">
          <el-button type="primary" @click="submitForm()" class="submitBtn">{{ $t('RESET PASSWORD') }}</el-button>
        </el-form-item>
        <el-form-item class="link">
          <router-link :to="{name: 'Login'}">{{ $t('Back to login') }}</router-link>
          <div class="passwordTip" :class="{error: !isValidPSW}">{{ $t('Between 8 and 20 characters') }}</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      const validatePassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('please input new password')))
        } else {
          callback()
        }
      }
      const validateConfirmPassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('please input new password again')))
        } else if(value !== this.resetForm.newPSW) {
          callback(new Error(this.$t('The passwords entered twice do not match')))
        } else {
          callback()
        }
      }
      return {
        fullLoading: false,
        resetForm: {
          newPSW: '',
          confirmNewPSW: '',
        },
        isValidPSW: true,
        rules: {
          newPSW: [
            {validator: validatePassword, trigger: 'blur'},
            {pattern: this.$store.state.pattern, message: ' '},
          ],
          confirmNewPSW: [
            {validator: validateConfirmPassword,},
          ]
        }
      };
    },
    methods: {
      submitForm() {
        this.$refs.resetForm.validate((valid) => {
          if (valid) {
            this.fullLoading = true
            const resetData = {
              sms_code: this.$store.state.resetForm.code,
              password: this.resetForm.newPSW,
              area_code	: this.$store.state.resetForm.phoneArea,
              phone: this.$store.state.resetForm.phone,
              account: this.$store.state.resetForm.number,
            }
            this.axios.post('/api/employee/auth/forgotPwd', resetData)
              .then((res) => {
                if (res.code === 200) {
                  this.$router.push({name: 'Home'})
                } else {
                  this.$alert(res.msg, {
                      confirmButtonText: this.$t('CLOSE'),
                      center: true,
                  })
                }
              }).finally(() => {
              this.fullLoading = false
            })
          } else {
            return false;
          }
        });
      },
      inputPassword() {
        this.$refs.resetForm.validateField('newPSW', (valid) => {
          valid ? this.isValidPSW=false : this.isValidPSW=true
        })
      }
    }
  }
</script>
